export default __webpack_public_path__ + "static/media/light_record_with_pin.f7c5de8c.svg";